import React from "react";
import { CustomList } from "components/index";
import { HoursCell } from "@/components/hours/cell";
import { TypeCell } from "@/modules/work/billables/cells";
import { StatusCell } from "@/components/status/cell";
import { DateCell } from "@/components/date/cell";
import { EmployeeCell } from "components/cell/employee/cell";
import { ROUTE } from "@/lib/utils";
import { formatHoursToTime } from "utils/timesheet";

const JCTimesheetSummaryList = ({ coordinatorId }) => {
  const [unreviewedHours, setUnreviewedHours] = React.useState(0);

  const columns = [
    {
      header: "Job",
      accessorKey: "name",
    },
    {
      header: "Project",
      accessorKey: "project.name",
    },

    {
      header: "Type",
      accessorKey: "type",
      cell: TypeCell,
    },
    {
      header: "Status",
      accessorKey: "status",
      cell: StatusCell,
    },
    {
      header: "JC",
      accessorKey: "job_coordinator",
      cell: EmployeeCell,
    },
    {
      header: "PC",
      accessorKey: "project_coordinator",
      cell: EmployeeCell,
    },
    {
      header: "Logged",
      accessorKey: "logged",
      cell: HoursCell,
    },
    {
      header: "Approved",
      accessorKey: "approved",
      cell: HoursCell,
    },
    {
      header: "Unapproved",
      accessorKey: "unapproved",
      cell: HoursCell,
    },
    {
      header: "Unreviewed",
      accessorKey: "unreviewed",
      cell: HoursCell,
    },
    {
      header: "End Date",
      accessorKey: "end_date",
      cell: DateCell,
    },
  ];

  const filters = {
    employeeId: coordinatorId,
  };

  return (
    <div key={coordinatorId}>
      <CustomList
        endPoint="custom-ui/get-jc-timesheet-summary-per-job"
        title={
          <div className="flex items-center gap-2">
            Unreviewed Hours as JC
            <span
              className={
                unreviewedHours >= 25
                  ? "bg-red-100 text-red-800 px-2 py-0.5 rounded-md"
                  : unreviewedHours >= 10
                    ? "bg-yellow-100 text-yellow-800 px-2 py-0.5 rounded-md"
                    : "bg-gray-100 text-gray-800 px-2 py-0.5 rounded-md"
              }
            >
              {formatHoursToTime(unreviewedHours)}
            </span>
          </div>
        }
        columns={columns}
        filters={filters}
        storageKey={`overview-jc-unreviewed-hours-${coordinatorId}`}
        hidePagination={true}
        perPage={100}
        href={(item) => ROUTE.JOB(item.id)}
        onDataChange={(response) => {
          setUnreviewedHours(response?.meta?.totals?.unreviewed || 0);
        }}
      />
    </div>
  );
};

export default JCTimesheetSummaryList;
